import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import GoToTop from './components/GoToTop';
import FixedContactIcons from './components/FixedContactIcons';

import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import HsmOffline from './pages/HsmOffline';
import AdmissionForm from './pages/AdmissionForm';
import Faq from './pages/Faq';
import Contact from './pages/Contact';

import AllInOne from './pages/AllInOne';
import BollywoodSinging from './pages/BollywoodSinging';
import DualProgram from './pages/DualProgram';
import Guitar from './pages/Guitar';
import HindustaniSinging from './pages/HindustaniSinging';
import MusicProduction from './pages/MusicProduction';
import OperaSinging from './pages/OperaSinging';
import Piano from './pages/Piano';
import Violin from './pages/Violin';
import WesternSinging from './pages/WesternSinging';

import TermsConditions from './pages/TermsConditions';
import TeacherTerms from './pages/TeacherTerms';
import LiveClass from './pages/LiveClass';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <ScrollToTopWrapper />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            style: {
              background: '#10b981',
            },
          },
          error: {
            duration: 4000,
            style: {
              background: '#ef4444',
            },
          },
        }}
      />
    </Router>
  );
}

function ScrollToTopWrapper() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // or "smooth"
    });
  }, [location.pathname]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/hsm-offline" element={<HsmOffline />} />
        <Route path="/admission-form" element={<AdmissionForm />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/teacher-policy" element={<TeacherTerms />} />

        <Route path="/guitar" element={<Guitar />} />
        <Route path="/piano" element={<Piano />} />
        <Route path="/opera-singing" element={<OperaSinging />} />
        <Route path="/western-singing" element={<WesternSinging />} />
        <Route path="/bollywood-singing" element={<BollywoodSinging />} />
        <Route path="/hindustani-singing" element={<HindustaniSinging />} />
        <Route path="/violin" element={<Violin />} />
        <Route path="/music-production" element={<MusicProduction />} />
        <Route path="/dual-program" element={<DualProgram />} />
        <Route path="/all-in-one" element={<AllInOne />} />

        <Route path="/live-class/:classId" element={<LiveClass />} />

        <Route path="/*" element={<NotFound />} />
      </Routes>
      <GoToTop />
      <FixedContactIcons />
    </>
  );
}

export default App;
